import { useTranslation } from "react-i18next";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import {
  ChevronRightIcon,
  InformationCircleIcon,
} from "@heroicons/react/outline";
import { UserType } from "../../context/AuthContext";
import SenderInfoModal from "../modal/views/sender-info/SenderInfoModal";
import { useCallback, useEffect, useState } from "react";
import { classNames, makeApiRequest } from "../../helpers";
import { getParticipantData } from "../../api/endpoints/chat/conversations";
import { ApiResponse } from "../../api/apiResponse";
type MessageBoxHeadProps = {
  senderName: string;
  senderType: UserType;
  senderImage?: string;
  setShowChatList: () => void;
  participantId: string | number;
};
export default function MessageBoxHead(props: MessageBoxHeadProps) {
  let { senderName, senderType, senderImage, setShowChatList, participantId } =
    props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [participantData, setParticipantData] = useState<any>({});
  const { t } = useTranslation("", {
    keyPrefix: "userType",
  });
  const getParticipant = useCallback(async () => {
    if (!!senderType && !!participantId) {
      const response = await getParticipantData({
        participant_type:
          senderType.charAt(0).toUpperCase() + senderType.slice(1),
        participant_id: participantId,
      });
      const { data } = response;
      setParticipantData(data);
    }
  }, [senderType, participantId]);
  if (senderType === UserType.Candidate) senderType = UserType.Student;
  useEffect(() => {
    getParticipant();
  }, [senderType, participantId]);
  return (
    <>
      <div className="sticky top-0 flex  items-center drop-shadow-sm bg-white gap-2 px-8 py-4 border-bottom border-gray-200">
        <ChevronRightIcon
          className="h-6 w-6 text-gray-500 ltr:rotate-180 md:hidden flex-shrink-0"
          aria-hidden="true"
          onClick={setShowChatList}
        />
        <UserProfilePictureAvatar
          profilePictureUrl={senderImage}
          className="  w-10 h-10 flex-shrink-0"
          alt={senderType}
        />
        <div className="flex flex-col w-full  justify-between gap-0.5">
          <h5
            className={classNames(
              "text-base font-semibold text-gray-800",
              senderType?.toLowerCase() === "supervisor" ? "hidden" : ""
            )}
          >
            {senderName}
          </h5>
          <p className="text-sm text-gray-500">
            {t(senderType?.toLowerCase())}
          </p>
        </div>
        <InformationCircleIcon
          onClick={() => setIsOpen(true)}
          className="h-6 w-6 text-gray-500 flex-shrink-0"
        />
      </div>
      {!!participantData && (
        <SenderInfoModal
          sponsorShip={participantData?.sponsorship?.sponsor?.name}
          telawah={
            participantData?.telawahs?.[0]?.name ??
            participantData?.telawah?.name
          }
          onClose={() => {
            setIsOpen(!isOpen);
          }}
          isOpen={isOpen}
          senderType={senderType}
          sender={participantData}
        />
      )}
    </>
  );
}
